import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Layout from "./layout/Layout";
import HomePage from "./views/HomePage/HomePage";
import Gallery from "./views/Gallery/Gallery";
import Contact from "./views/Contact/Contact";
import Error404 from "./views/Error404/Error404";

export default function App() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes key={location.pathname} location={location}>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="galeria" element={<Gallery />} />
          <Route path="kontakt" element={<Contact />} />
          <Route path="*" element={<Error404 />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}
